'use client';

import { useTranslations } from 'next-intl';

const SPINNER_ACCENT = '#116dff';

export function WorkbenchPageLoader() {
  const t = useTranslations();

  return (
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white text-foreground">
      <div
        className="h-8 w-8 animate-spin rounded-full border-2 border-transparent"
        style={{ borderTopColor: SPINNER_ACCENT }}
      />
      <p className="mt-3 text-sm text-muted-foreground">
        {t('get-feedback-workbench-loading')}
      </p>
    </div>
  );
}
